import { plugin, Mode } from 'light-component';
import { useTranslation } from '@common';
import { WidgetType } from '../types';
import { Thumbnail } from '../../component';
import { ShotEyesSignatureInputMode } from './input';
import { ShotEyesSignatureDesignMode } from './design';
import { ShotEyesSignatureViewMode } from './view';
import type { ReactElement } from 'react';
import type { ShotEyesSignatureProps } from './types';

export function Signature(props: ShotEyesSignatureProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (<Thumbnail icon='ShotEyesSignatureIcon' title={t('ShotEyesSignature')} toolTipContent={t('ShotEyesSignature')} />);
  }

  if (props.mode === Mode.DESIGN) {
    return (<ShotEyesSignatureDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<ShotEyesSignatureViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<ShotEyesSignatureInputMode {...props} />);
  }

  return null;
}

Signature.prototype.type = WidgetType.SHOTEYES_SIGNATURE;
plugin.register({ kind: 'widget', component: Signature });
